import React from 'react';
import './ContentSection.css';

function ContentSection({ 
  title, 
  description, 
  image, 
  imageAlt, 
  imageOnRight = false,
  buttonText,
  buttonLink,
  className = ''
}) {
  return (
    <section className={`content-section ${className}`}>
      <div className="content-wrapper">
        <div className={`content-container ${imageOnRight ? 'image-right' : 'image-left'}`}>
          <div className="content-image">
            <img src={image} alt={imageAlt} />
          </div>
          <div className="content-text">
            <h2>{title}</h2>
            <p>{description}</p>
            {buttonText && (
              <a href={buttonLink} className="content-button">
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContentSection; 